module.exports = __webpack_public_path__ + "static/media/i-am-out-are-you-in.cca9aad1.txt";